// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__P1AEv","content":"styles_content__wIm3E"};